import {
  SideNavCategory,
  SideNavCategoryTypeName,
} from '../../../components/side-nav';
import { ReportField } from '../../../models';

// Formats and adds MyFields to the Searchable Category (hidden)
export default function combineMyFieldsWithSearchableCategories(
  allCategories: SideNavCategory<ReportField>[],
  myFieldsCategory: SideNavCategory<ReportField>,
): SideNavCategory[] {
  const searchableCategory = allCategories.filter(
    (x) => x.key === SideNavCategoryTypeName.Searchable,
  )[0]?.items;

  myFieldsCategory.items.forEach((x) => {
    x.formattedSearchText = x.name;
    searchableCategory?.unshift(x);
  });

  return allCategories;
}
